const carrierMap = {
  fedex: 'FedEx',
  ups: 'UPS',
  usps: 'USPS',
  CanadaPost: 'Canada Post',
  UPSMailInnovations: 'UPS',
  FedExSmartPost: 'FedEx',
  UPSSurePost: 'UPS',
  pickup: 'Pickup',
  UPSDAP: 'UPS',
  FedExDefault: 'FedEx'
}

export default carrierName => carrierMap[carrierName] || carrierName
